var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWrite = function SvgWrite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "current",
    height: "current",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 5.56 14.44 2.8a1.037 1.037 0 0 0-1.48 0l-9.47 9.48c-.15.15-.26.35-.3.56l-.69 3.43c-.07.34.04.69.28.94.2.2.46.31.74.31.07 0 .14 0 .21-.02l3.43-.69c.21-.04.41-.15.56-.3l9.48-9.48c.41-.41.41-1.07 0-1.47ZM6.87 15.59l-3.08.62.62-3.08 7.02-7.02 2.46 2.46-7.02 7.02Zm7.9-7.9-2.46-2.46 1.39-1.39 2.46 2.46-1.39 1.39Z",
    fill: "current"
  })));
};
export default SvgWrite;